import * as React from 'react';

import { Box, Text } from '@opendoor/bricks-next';
import { IAddressInputAddress } from '@opendoor/cinderblocks/growth/AddressInput/AddressInput';

import AddressInput from '../shared/NewAddressInput';

interface IAddressEntryPageProps {
  onChooseManualEntry: () => void;
  onSubmit: (address: IAddressInputAddress) => void;
}

export class AddressEntryPage extends React.PureComponent<IAddressEntryPageProps> {
  public render() {
    return (
      <Box
        gap="$10x"
        padding="$10x"
        $smallerThanMD={{
          width: '100%',
        }}
      >
        <Text
          tag="h1"
          textAlign="center"
          $largerThanSM={{
            textAlign: 'left',
            typography: '$subheaderXsmall',
          }}
          typography="$subheaderSmall"
        >
          Unsubscribe from mail
        </Text>
        <Text
          tag="h3"
          textAlign="center"
          $largerThanSM={{
            textAlign: 'left',
            typography: '$bodyMedium',
          }}
          typography="$bodySmall"
        >
          Please enter the address where you would no longer like to receive mail from Opendoor.
        </Text>

        <AddressInput
          onChooseManualEntry={this.props.onChooseManualEntry}
          onSubmit={this.props.onSubmit}
          showCta
          // @ts-expect-error: Type mismatch caused by withRouter's inability to infer the correct variant of IProps (either AddressInputProps or AddressInputWithCtaProps).
          // We know that ctaProps will be conditionally passed
          ctaProps={{ actionText: 'Unsubscribe', 'aria-label': '' }}
        />
      </Box>
    );
  }
}
